export default "__VITE_ASSET__LsX7Yqe3__"